// 進捗バー関連処理
export function calcPointsRateProgress(subtotal: number) {
  let missingAmount = 0;
  let percent = 1;

  if (subtotal < priceThreshold.percent2) {
    percent = 1;
    missingAmount = priceThreshold.percent2 - subtotal;
  } else if (subtotal < priceThreshold.percent3) {
    percent = 2;
    missingAmount = priceThreshold.percent3 - subtotal;
  } else if (subtotal < priceThreshold.percent4) {
    percent = 3;
    missingAmount = priceThreshold.percent4 - subtotal;
  } else if (subtotal < priceThreshold.percent5) {
    percent = 4;
    missingAmount = priceThreshold.percent5 - subtotal;
  } else {
    percent = 5;
  }

  return {
    percent,
    missingAmount: missingAmount.toLocaleString(),
    progressWidth: calcWidthProgress(subtotal, percent) + '%',
  };
}

// 金額しきい値
const priceThreshold = {
  percent2: 6000,
  percent3: 10000,
  percent4: 15000,
  percent5: 20000,
};

// 進捗バー幅 (SubscriptionList.scssのlabelと同期)
const progressWidth = {
  percent2: 10,
  percent3: 37,
  percent4: 64,
  percent5: 91,
};

// 進捗バー幅取得
function calcWidthProgress(total: number, percent: number) {
  let highThreshold = 0;
  let lowThreshold = 0;
  let highWidth = 0;
  let lowWidth = 0;

  if (percent === 1) {
    highThreshold = priceThreshold.percent2;
    lowThreshold = 0;
    highWidth = progressWidth.percent2;
    lowWidth = 0;
  } else if (percent === 2) {
    highThreshold = priceThreshold.percent3;
    lowThreshold = priceThreshold.percent2;
    highWidth = progressWidth.percent3;
    lowWidth = progressWidth.percent2;
  } else if (percent === 3) {
    highThreshold = priceThreshold.percent4;
    lowThreshold = priceThreshold.percent3;
    highWidth = progressWidth.percent4;
    lowWidth = progressWidth.percent3;
  } else if (percent === 4) {
    highThreshold = priceThreshold.percent5;
    lowThreshold = priceThreshold.percent4;
    highWidth = progressWidth.percent5;
    lowWidth = progressWidth.percent4;
  } else {
    return 100;
  }

  return (
    lowWidth + ((total - lowThreshold) / (highThreshold - lowThreshold)) * (highWidth - lowWidth)
  );
}
